const { featureToggles = [] } = window.stacc_env

/**
 * Check if the current portal is the Sweden portal
 * @returns true if 'se-portal' feature toggle is enabled
 */
export const isSwedenPortal = featureToggles.includes('se-portal')

/**
 * Check if the current portal is the Norway portal
 * @returns true if 'se-portal' feature toggle is NOT enabled
 */
export const isNorwayPortal = !isSwedenPortal
